import React, { useEffect, useState } from 'react';
import { FiFileText, FiRefreshCw } from 'react-icons/fi';
import api from '../services/api';
import { useLanguage } from '../i18n/LanguageContext';

const AuditLogs = () => {
  const { t } = useLanguage();
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const actionColors: any = {
    block_device: 'bg-red-500/20 text-red-400',
    unblock_device: 'bg-green-500/20 text-green-400',
    shutdown_device: 'bg-orange-500/20 text-orange-400',
    block_group: 'bg-red-500/20 text-red-400',
  };

  const fetchLogs = async () => {
    try {
      const res = await api.get('/audit');
      setLogs(res.data);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  useEffect(() => { fetchLogs(); }, []);

  const getActionLabel = (action: string) => {
    const map: any = {
      block_device: t('blockDeviceLog'),
      unblock_device: t('unblockDeviceLog'),
      shutdown_device: t('shutdownDeviceLog'),
      block_group: t('blockGroupLog'),
    };
    return map[action] || action;
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="text-slate-400">Loading...</div></div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-white text-3xl font-bold">{t('logs')}</h1>
        <button onClick={fetchLogs} className="flex items-center gap-2 bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg transition-colors">
          <FiRefreshCw />{t('refresh')}
        </button>
      </div>

      {logs.length === 0 ? (
        <div className="bg-slate-800 rounded-2xl p-12 text-center">
          <FiFileText className="text-slate-600 text-6xl mx-auto mb-4" />
          <p className="text-slate-400 text-lg">{t('noLogs')}</p>
        </div>
      ) : (
        <div className="bg-slate-800 rounded-2xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-700">
                <th className="text-left text-slate-400 font-medium px-6 py-4">{t('action')}</th>
                <th className="text-left text-slate-400 font-medium px-6 py-4">{t('user')}</th>
                <th className="text-left text-slate-400 font-medium px-6 py-4">{t('device')}</th>
                <th className="text-left text-slate-400 font-medium px-6 py-4">{t('ipAddress')}</th>
                <th className="text-left text-slate-400 font-medium px-6 py-4">{t('time')}</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id} className="border-b border-slate-700/50 hover:bg-slate-700/30">
                  <td className="px-6 py-4">
                    <span className={`px-3 py-1 rounded-full text-sm ${actionColors[log.action] || 'bg-slate-500/20 text-slate-400'}`}>
                      {getActionLabel(log.action)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-slate-300">{log.user_email || '—'}</td>
                  <td className="px-6 py-4 text-slate-300">{log.hostname || '—'}</td>
                  <td className="px-6 py-4 text-slate-400 text-sm">{log.ip_address || '—'}</td>
                  <td className="px-6 py-4 text-slate-400 text-sm">{new Date(log.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditLogs;
